// ==================== ENUMS ====================

/**
 * User role type - matches Prisma's UserRole enum values
 * Using string literal union for compatibility with Prisma enum
 */
export type InternalUserRole = 'ADMIN' | 'SUPER_ADMIN' | 'EDITOR';
export type UserRole = InternalUserRole | 'COMPANY_ADMIN';

export const INTERNAL_USER_ROLES: readonly InternalUserRole[] = ['ADMIN', 'SUPER_ADMIN', 'EDITOR'];

export const UserRoleValues = {
  ADMIN: 'ADMIN' as const,
  SUPER_ADMIN: 'SUPER_ADMIN' as const,
  EDITOR: 'EDITOR' as const,
  COMPANY_ADMIN: 'COMPANY_ADMIN' as const,
};

// ==================== BASE USER TYPE ====================

/**
 * Base user interface for API responses (no password, no methods)
 * This is the client-safe user type
 */
export interface UserDto {
  id: string;
  email: string;
  firstname: string;
  lastname: string;
  role: UserRole;
  status?: 'ACTIVE' | 'SUSPENDED' | 'DELETED' | 'UNMAPPED';
  tablePreferences: Record<string, string>[] | null;
  createdAt: Date;
  updatedAt: Date;
}

// Get One
export type UserResponseDto = UserDto;

// Get Many
export interface GetUsersParams {
  pageSize?: number;
  page?: number;
  search?: string;
  sortField?: string;
  sort?: string;
}

export type UsersResponseDto = {
  data: UserDto[];
  rowCount: number;
};

export type UsersRowsRequest = {
  page: number;
  pageSize: number;
  sortModel: { field: string; sort: 'asc' | 'desc' };
  search: string;
};

// Add/Edit interfaces (client-safe, no decorators)
export interface AddUserData {
  email: string;
  firstname: string;
  role: string;
  lastname: string;
}

export interface EditUserData {
  role?: string;
  status?: 'ACTIVE' | 'SUSPENDED';
}

export type UserAssigneeDto = Pick<UserDto, 'id' | 'email' | 'firstname' | 'lastname'>;

export interface ChangePasswordData {
  password: string;
  passwordConfirm: string;
}

export type AddEditUserResponseDto = UserDto;
export type ChangePasswordResponseDto = Record<string, never>;
export type DeleteUserResponseDto = Record<string, never>;

// Keep these for backward compatibility with existing client imports
export type AddUserRequestDto = AddUserData;
export type EditUserRequestDto = EditUserData;
export type GetUsersRequestDto = GetUsersParams;
export type ChangePasswordRequestDto = ChangePasswordData;
